import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon CaretLeftIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const CaretLeftIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 11 20">
      <path d="M8.8 20a2.16 2.16 0 01-1.67-.78l-6.6-7.77a2.24 2.24 0 010-2.9L7.13.77a2.19 2.19 0 013.1-.24 2.25 2.25 0 01.24 3.14L5.1 10l5.37 6.33a2.24 2.24 0 01-.24 3.13A2.16 2.16 0 018.8 20z" />
    </Icon>
  )
}
export default CaretLeftIcon
